var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllFlags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 32,
    viewBox: "0 0 133 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8427_53158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80709 6.26562C2.55028 7.90081 1.60259 9.7855 1.05078 11.8329H9.3744L3.80709 6.26562Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9485 11.8329C31.3967 9.7855 30.4489 7.90081 29.1922 6.26562L23.625 11.8329H31.9485Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05078 20.1797C1.60266 22.2271 2.55034 24.1118 3.80709 25.7469L9.37422 20.1797H1.05078Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2411 3.31106C24.6059 2.05425 22.7213 1.10656 20.6738 0.554688V8.87825L26.2411 3.31106Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75879 28.6921C8.39398 29.9489 10.2787 30.8966 12.326 31.4485V23.125L6.75879 28.6921Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.326 0.554688C10.2786 1.10656 8.39391 2.05425 6.75879 3.311L12.326 8.87819V0.554688Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6738 31.4485C22.7212 30.8966 24.6059 29.9489 26.241 28.6922L20.6738 23.125V31.4485Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 20.1797L29.1922 25.7469C30.4489 24.1118 31.3967 22.2271 31.9485 20.1797H23.625Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3646 13.9131H18.5871H18.587V0.135438C17.9038 0.0465 17.2073 0 16.5 0C15.7926 0 15.0962 0.0465 14.4131 0.135438V13.9129V13.913H0.635438C0.5465 14.5962 0.5 15.2927 0.5 16C0.5 16.7074 0.5465 17.4038 0.635438 18.0869H14.4129H14.413V31.8646C15.0962 31.9535 15.7926 32 16.5 32C17.2073 32 17.9038 31.9536 18.5869 31.8646V18.0871V18.087H32.3646C32.4535 17.4038 32.5 16.7074 32.5 16C32.5 15.2927 32.4535 14.5962 32.3646 13.9131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6738 20.1719L27.8136 27.3117C28.142 26.9834 28.4552 26.6402 28.7541 26.2845L22.6415 20.1719H20.6738V20.1719Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3263 20.1719H12.3262L5.18652 27.3116C5.51477 27.6399 5.85796 27.9532 6.21371 28.2521L12.3263 22.1393V20.1719Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3263 11.8274V11.8273L5.18659 4.6875C4.85822 5.01575 4.54497 5.35894 4.24609 5.71469L10.3588 11.8274H12.3263V11.8274Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6738 11.8225L27.8136 4.68263C27.4854 4.35425 27.1422 4.041 26.7865 3.74219L20.6738 9.85487V11.8225Z",
    fill: "#D80027"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8427_53158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 32C45.3366 32 52.5 24.8366 52.5 16C52.5 7.16344 45.3366 0 36.5 0C27.6634 0 20.5 7.16344 20.5 16C20.5 24.8366 27.6634 32 36.5 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8037 16.0021H52.4993C52.4993 14.5579 52.3068 13.1589 51.9481 11.8281H35.8037V16.0021Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8037 7.6505H50.151C49.1715 6.05225 47.9192 4.63956 46.4591 3.47656H35.8037V7.6505Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4998 31.9939C40.2653 31.9939 43.7264 30.6924 46.4595 28.5156H26.54C29.2732 30.6924 32.7342 31.9939 36.4998 31.9939Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.848 24.3458H50.1512C50.9375 23.0628 51.5473 21.6603 51.9484 20.1719H21.0508C21.4518 21.6603 22.0617 23.0628 22.848 24.3458Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9115 2.49863H29.3696L28.0133 3.48394L28.5314 5.07825L27.1752 4.09294L25.819 5.07825L26.2665 3.70094C25.0724 4.69562 24.0257 5.861 23.1632 7.1595H23.6304L22.7671 7.78669C22.6326 8.01106 22.5036 8.239 22.38 8.47031L22.7922 9.73913L22.0231 9.18031C21.8319 9.58537 21.6571 9.99956 21.4999 10.4224L21.9541 11.8204H23.6304L22.2742 12.8057L22.7922 14.4L21.4361 13.4147L20.6237 14.0049C20.5424 14.6586 20.5 15.3243 20.5 16H36.5C36.5 7.1635 36.5 6.12175 36.5 0C33.3393 0 30.3928 0.916875 27.9115 2.49863ZM28.5314 14.4L27.1752 13.4147L25.819 14.4L26.3371 12.8057L24.9808 11.8204H26.6572L27.1752 10.2261L27.6932 11.8204H29.3696L28.0133 12.8057L28.5314 14.4ZM28.0133 8.14481L28.5314 9.73913L27.1752 8.75381L25.819 9.73913L26.3371 8.14481L24.9808 7.1595H26.6572L27.1752 5.56519L27.6932 7.1595H29.3696L28.0133 8.14481ZM34.2705 14.4L32.9143 13.4147L31.5581 14.4L32.0762 12.8057L30.7199 11.8204H32.3963L32.9143 10.2261L33.4323 11.8204H35.1087L33.7524 12.8057L34.2705 14.4ZM33.7524 8.14481L34.2705 9.73913L32.9143 8.75381L31.5581 9.73913L32.0762 8.14481L30.7199 7.1595H32.3963L32.9143 5.56519L33.4323 7.1595H35.1087L33.7524 8.14481ZM33.7524 3.48394L34.2705 5.07825L32.9143 4.09294L31.5581 5.07825L32.0762 3.48394L30.7199 2.49863H32.3963L32.9143 0.904312L33.4323 2.49863H35.1087L33.7524 3.48394Z",
    fill: "#0052B4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8427_53158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5 32C65.3366 32 72.5 24.8366 72.5 16C72.5 7.16344 65.3366 0 56.5 0C47.6634 0 40.5 7.16344 40.5 16C40.5 24.8366 47.6634 32 56.5 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4996 15.9983C72.4996 9.65494 68.808 4.17394 63.4561 1.58594V30.4106C68.808 27.8227 72.4996 22.3417 72.4996 15.9983Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 15.9983C40.5 22.3417 44.1916 27.8227 49.5435 30.4107V1.58594C44.1916 4.17394 40.5 9.65493 40.5 15.9983Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2824 18.0815L62.0649 16.6902L60.6737 15.9946V14.6032L57.8911 15.9946L59.2824 13.2119H57.8911L56.4998 11.125L55.1084 13.2119H53.7171L55.1084 15.9946L52.3258 14.6032V15.9946L50.9346 16.6902L53.7171 18.0815L53.0215 19.4728H55.8041V21.5597H57.1954V19.4728H59.978L59.2824 18.0815Z",
    fill: "#D80027"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8427_53158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5 32C85.3366 32 92.5 24.8366 92.5 16C92.5 7.16344 85.3366 0 76.5 0C67.6634 0 60.5 7.16344 60.5 16C60.5 24.8366 67.6634 32 76.5 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2562 9.73438L70.6375 13.9844H75.1062L71.4937 16.6156L72.875 20.8656L69.2562 18.2406L65.6375 20.8656L67.025 16.6156L63.4062 13.9844H67.875L69.2562 9.73438Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4689 24.7797L78.4127 23.4797L76.8502 24.0859L77.7564 22.6797L76.7002 21.3734L78.3189 21.8047L79.2314 20.3984L79.3189 22.0734L80.9439 22.5047L79.3752 23.1047L79.4689 24.7797Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5689 20.9672L82.0689 19.3672L80.7002 18.3984L82.3752 18.3734L82.8689 16.7734L83.4127 18.3609L85.0877 18.3422L83.7439 19.3422L84.2814 20.9297L82.9127 19.9609L81.5689 20.9672Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3998 11.7391L83.6623 13.2453L84.8623 14.4141L83.2061 14.1766L82.4686 15.6766L82.1811 14.0266L80.5186 13.7891L82.0061 13.0078L81.7186 11.3516L82.9186 12.5203L84.3998 11.7391Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5129 7.17969L79.3879 8.84844L80.9441 9.47969L79.3129 9.87969L79.1941 11.5547L78.3129 10.1297L76.6816 10.5297L77.7629 9.24844L76.8754 7.82969L78.4316 8.46094L79.5129 7.17969Z",
    fill: "#FFDA44"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_8427_53158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5 32C105.337 32 112.5 24.8366 112.5 16C112.5 7.16344 105.337 0 96.5 0C87.6634 0 80.5 7.16344 80.5 16C80.5 24.8366 87.6634 32 96.5 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5003 0C90.1569 0 84.6759 3.69156 82.0879 9.0435H110.913C108.325 3.69156 102.844 0 96.5003 0Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5003 32.0044C102.844 32.0044 108.325 28.3129 110.913 22.9609H82.0879C84.6759 28.3129 90.1569 32.0044 96.5003 32.0044Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4998 21.5601C99.5733 21.5601 102.065 19.0684 102.065 15.9949C102.065 12.9213 99.5733 10.4297 96.4998 10.4297C93.4262 10.4297 90.9346 12.9213 90.9346 15.9949C90.9346 19.0684 93.4262 21.5601 96.4998 21.5601Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4997 19.4799C98.4207 19.4799 99.978 17.9227 99.978 16.0017C99.978 14.0807 98.4207 12.5234 96.4997 12.5234C94.5787 12.5234 93.0215 14.0807 93.0215 16.0017C93.0215 17.9227 94.5787 19.4799 96.4997 19.4799Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5003 11.7109L97.5733 14.1446L100.217 13.857L98.6463 16.0031L100.217 18.1491L97.5733 17.8616L96.5003 20.2952L95.4272 17.8616L92.7832 18.1491L94.3542 16.0031L92.7832 13.857L95.4272 14.1446L96.5003 11.7109Z",
    fill: "#0052B4"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_8427_53158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.5 16.0031C100.5 17.9602 100.852 19.8349 101.495 21.5682L116.5 22.2639L131.505 21.5683C132.148 19.8349 132.5 17.9602 132.5 16.0031C132.5 14.0459 132.148 12.1712 131.505 10.4379L116.5 9.74219L101.495 10.4378C100.852 12.1712 100.5 14.0459 100.5 16.0031V16.0031Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5 0C109.62 0 103.756 4.342 101.495 10.4348H131.505C129.244 4.342 123.379 0 116.5 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.505 21.5703H101.495C103.756 27.6631 109.62 32.0051 116.5 32.0051C123.379 32.0051 129.244 27.6631 131.505 21.5703Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5 10.4297L117.881 14.6809H122.352L118.735 17.3086L120.116 21.5601L116.5 18.9326L112.883 21.5601L114.265 17.3086L110.648 14.6809H115.119L116.5 10.4297Z",
    fill: "black"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8427_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8427_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8427_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8427_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_8427_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_8427_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllFlags);
export default __webpack_public_path__ + "static/media/all-flags.61baad350df0349f63864d2814770172.svg";
export { ForwardRef as ReactComponent };